module.exports = __webpack_public_path__ + "img/screen3.f7423864.jpg";